module.exports = __webpack_public_path__ + "static/media/icon_url.64d592ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_url.svg
// module id = 242
// module chunks = 0